import React from "react";
import { Text, View, StyleSheet } from "@react-pdf/renderer";

const borderColor = "#40A7FE";
const styles = StyleSheet.create({
  row: {
    flexDirection: "row",
    borderBottomColor: "#40A7FE",
    borderBottomWidth: 1,
    alignItems: "center",
    height: 24,
    fontSize: 12,
    fontStyle: "bold",
  },
  description: {
    width: "85%",
    textAlign: "right",
    borderRightColor: borderColor,
    borderRightWidth: 1,
    paddingRight: 8,
  },
  total: {
    width: "15%",
    textAlign: "right",
    paddingRight: 8,
  },
});

const DetailPdfTableFooter = ({ items }) => {
  // const total = items
  //   .map((item) => item.qty * item.rate)
  //   .reduce((accumulator, currentValue) => accumulator + currentValue, 0);
  console.log('Total_items', items)
  return (
    <View style={styles.row}>
      <Text style={styles.description}>TOTAL</Text>
      <Text style={styles.total}>
        {items.totalHours}
      </Text>
    </View>
  );
};

export default DetailPdfTableFooter;
